export default __webpack_public_path__ + "static/media/nithin.c36b018c.jpg";